import { createNS } from "@ontologies/core";

const dbpedia = createNS("http://dbpedia.org/resource/");

export default {
  ns: dbpedia,
};
